import Vue from 'vue';
import { Component, Ref, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { UseService } from '@/services/service';
import CurrentUserService from '@/services/current-user.service';
import flagEn from '@/assets/icons/flags/en.png';
import flagVi from '@/assets/icons/flags/vi.png';
import flagJa from '@/assets/icons/flags/ja.png';
import { fileToBase64 } from '@/helper/file';
import { StaffEntity } from '@/entities/staff.entity';
import { Language, setLanguage } from '@/bootstrap/heplers/vue-i18n';

@Component<SettingMixin>({
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class SettingMixin extends Vue {
  currentStaff!: StaffEntity;

  @Ref('fileInput')
  readonly fileInput!: HTMLInputElement;

  @UseService(CurrentUserService)
  service: CurrentUserService;

  userData: Partial<StaffEntity> = {
    defaultGiftPoint: [0, 0, 0, 0, 0],
    receivePostNotification: undefined,
    receiveThanksNotification: undefined,
    receiveTalkNotification: undefined,
    name: undefined,
    email: undefined,
    birthDay: undefined,
    gender: undefined,
    lang: undefined,
    request: undefined,
    cumulative: undefined,
  };

  password: string = null;
  passwordConfirm: string = null;

  supportLanguages: Language[] = ['ja', 'vi', 'en'];

  flags: Record<Language, string> = {
    en: flagEn,
    vi: flagVi,
    ja: flagJa,
  };

  avatar: string = null;
  avatarFile: File = null;

  isValidImage = false;

  @Watch('userData.defaultGiftPoint', { deep: true })
  handleChange(val) {
    this.userData.defaultGiftPoint = val;
  }

  created() {
    this.userData.defaultGiftPoint = this.currentStaff.defaultGiftPoint || [1, 1, 1, 1, 1];
    this.userData.receivePostNotification = this.currentStaff.receivePostNotification;
    this.userData.receiveThanksNotification = this.currentStaff.receiveThanksNotification;
    this.userData.receiveTalkNotification = this.currentStaff.receiveTalkNotification;
    this.userData.name = this.currentStaff.name;
    this.userData.email = this.currentStaff.email;
    this.userData.birthDay = this.currentStaff.birthDay;
    this.userData.gender = this.currentStaff.gender;
    this.userData.lang = this.currentStaff.lang;
    this.userData.request = this.currentStaff.request;
    this.userData.cumulative = this.currentStaff?.cumulative;
    this.avatar = this.currentStaff.avatar;
  }

  changeLanguage(lang: Language) {
    this.userData.lang = lang;
    setLanguage(this.$i18n, lang);
  }
  resetPassword() {
    this.password = null;
    this.passwordConfirm = null;
  }
  canNotify(): boolean {
    let flag: boolean = Object.keys(this.userData).some((key) => {
      if (key === 'defaultGiftPoint') {
        const f = this.userData.defaultGiftPoint.every(
          (item, index) => item === this.currentStaff.defaultGiftPoint[index],
        );
        return !f;
      }
      return JSON.stringify(this.userData[key]) !== JSON.stringify(this.currentStaff[key]);
    });

    if (this.password) flag = true;
    this.resetPassword();
    return flag;
  }

  async save() {
    try {
      const data: Partial<StaffEntity> = this.userData;
      if (this.password) {
        data.password = this.password;
      }
      await this.service.update(data);
      if (this.avatarFile && !this.isValidImage) {
        console.log('update image');
        await this.service.uploadAvatar(this.avatarFile);
        this.avatarFile = null;
      }
      if (data.password) {
        delete data.password;
      }
      if (this.canNotify()) {
        await this.$cheeers.notify({
          text: this.$t('setting.updated'),
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async browseAvatarFile() {
    this.fileInput.click();
  }

  async changeTmpAvatar() {
    const {size} = this.fileInput.files[0];
    const limitSize = 2 * 1024 * 1024
    if(size <= limitSize) {
      if (this.fileInput.files && this.fileInput.files.length > 0) {
        this.avatar = await fileToBase64(this.fileInput.files[0]);
        [this.avatarFile] = this.fileInput.files;
        this.isValidImage = false;
      }
    } else {
      this.isValidImage = true;
    }
  }
}
